import { VFC } from 'react'
import { useForm } from 'react-hook-form'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { _profilegreen, black, truewhite } from 'src/styles/colors'
import { fontWeightBold, fontWeightMedium } from 'src/styles/font'
import styled from 'styled-components'

type RenameOrDeleteTagModalProps = {
  submit: () => Promise<void>
  typeText: '編集' | '削除'
}
const RenameOrDeleteTagModalContent: VFC<
  ModalProps<RenameOrDeleteTagModalProps>
> = ({ close, submit, typeText }) => {
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm()

  const handleOnSubmit = async ({}) => {
    await submit()
    close()
  }

  return (
    <Layout>
      <FormTitle>{`このタグを${typeText}しますか？`}</FormTitle>
      <FormCaption>
        {`タグを${typeText}すると、既存のルームに割り当てられているタグも${typeText}されます。`}
      </FormCaption>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <ModalButtons>
          <CancelButton type="button" onClick={close}>
            キャンセル
          </CancelButton>
          <SaveButton type="submit" disabled={isSubmitting}>
            {`${typeText}する`}
          </SaveButton>
        </ModalButtons>
      </form>
    </Layout>
  )
}

export const RenameOrDeleteTagModal = asModal(RenameOrDeleteTagModalContent)

const Layout = styled.div`
  width: 80vw;
  max-width: 400px;
  padding: 5%;
  border-radius: 10px;
  background-color: ${truewhite};
  line-height: 1.3rem;
`

const FormTitle = styled.h2`
  font-size: 17px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
  font-weight: ${fontWeightBold};
`

const FormCaption = styled.p`
  margin-bottom: 40px;
  font-size: 13px;
  color: ${black};
  font-weight: ${fontWeightMedium};
`

const ModalButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;

  button {
    text-align: center;
    padding: 5px 21px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: ${fontWeightBold};
    line-height: 1.4;
    white-space: normal;
  }

  @media screen and (max-width: 540px) {
    display: block;
  }
`

const SaveButton = styled.button`
  color: ${truewhite};
  background: ${_profilegreen};
`

const CancelButton = styled.button`
  color: ${_profilegreen};
`
